{
  "eventDetails": "Dettagli dell'evento",
  "helpContentBodyText": "Visualizza i 10 eventi più recenti segnalati da questo dispositivo.\n\nVisualizza i report di diversi sensori toccandoli/cliccandoli in Sensori di segnalazione.\n\nVisualizza gli eventi più vecchi e più recenti toccando/cliccando su \"più vecchi\" e \"più recenti\".",
  "linkTo": "Eventi",
  "noDataForSensorWithSensorName": "Nessun dato per il sensore {{sensorName}}",
  "noOlderEventsFoundForThisDevice": "Non sono stati trovati eventi precedenti per questo dispositivo.",
  "reportingSensors": "Sensori di segnalazione",
  "sensorReport": "{{sensorName}} Rapporto sensore",
  "subheader": "Fare clic/toccare per ispezionare",
  "title": "Cronologia degli eventi"
}
